import axios from 'axios';
import router from '@/router';
import { message } from 'ant-design-vue'

import store from '@/store';
const service = axios.create({
  baseURL: '/back',
  timeout: 120000
})
//请求头 token 封装
service.defaults.headers.post['Content-Type'] = 'application/json';

service.interceptors.request.use(
  config => {
    if (localStorage.getItem('pctoken') != null && localStorage.getItem('pctoken') != undefined)
      config.headers["token"] = localStorage.getItem('pctoken');
    return config;


  },
  error => {
    return Promise.reject(error)
  }
);
// http response l拦截器
service.interceptors.response.use(
  response => {
    console.log(response)
    if (response.status === 200) {
      if (response.data.code == "000000" || response.data.state == "SUCCESS" || response.data.code == "200" || response.data.code == 200 || response.data.code == "200" || response.headers['content-type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' || response.headers['content-type'] == "application/vnd.ms-excel;charset=UTF-8" || response.headers['content-type'] == 'application/vnd.ms-excel;charset=utf-8' || response.headers['content-type'] == "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8") {
        return response
      }

      else {
        if (response.config.url.indexOf('companyAdminOperateClient') > -1 || response.config.url.indexOf('/chat/chat') > -1) {
          return response
        }
        else if (response.config.url.indexOf('reportArticleList') > -1 || response.config.url.indexOf('webLoginUser') > -1 || response.config.url.indexOf('getUnionid') > -1) {
          return response
        }
        //020000 表示token过期
        else if (response.data.code == '020000') {
          store.dispatch('exitAccount', null)
          return Promise.reject();
        } else if (response.data.code == '020001') {
          store.dispatch('exitAccount', null)
          return Promise.reject();
        } 
//020003 密码错误
        else if (response.data.code == '020002' ||response.data.code == '020003') {
         
          return response;
        }
        else {
          message.error(response.data.msg || '系统异常');

          if(response.data.code!='-1'){
            var href = window.location.href

            if (href.indexOf('http://qb.cbio.vip:81') > -1 || href.indexOf(' http://10.0.0.103:8080/') > -1) {
              setTimeout(() => {
                store.dispatch('exitAccount', null)
                return Promise.reject();
              }, 2000)
            }
            else {
              store.dispatch('exitAccount', null)
              return Promise.reject();
            }
  
          }
        }
      }
    }
    else {
      return response
    }
  },

  error => {
    message.error(error.response.status);
    store.dispatch('exitAccount', null)
    return Promise.reject(error.response);
  }
)
//get
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params: params
    }).then(response => {

      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}
//getMethod
export function getMethod(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.get(url + "/" + data.id, {
      params: data.data
    }).then(response => {
      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}
//getToken
export function getToken(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data).then(response => {
      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}
//post
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data,{
      headers: {
        "Content-Type": "application/json", // 强制指定 JSON
      },
    })
      .then(response => {
        resolve(response?response.data:response);
      }, err => {
        reject(err)
      })
  })
}
//postMethod
export function postMethod(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url + "/" + data.id, null, { params: data.data })
      .then(response => {

        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}
export function postGet(url, data = {}) {
  return new Promise((resolve, reject) => {

    
    url=url+"?" + new URLSearchParams(data.get).toString()
  
    service.post(url,data.post)
      .then(response => {

        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}
export function  postGetUpLoad(url, data = {}) {
  return new Promise((resolve, reject) => {

    
    url=url+"?" + new URLSearchParams(data.get).toString()
    service.defaults.headers['Content-Type'] = 'multipart/form-data';
    service.post(url,data.post)
      .then(response => {

        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

export function downLoad(url, params = {}) {
  console.log("downLoad====")

  return new Promise((resolve, reject) => {
    console.log(service)
    service.defaults.timeout = 5000000
    service.get(url, {
      params: params, responseType: 'blob'
    },)
      .then(response => {
        console.log(response, 'response')
        resolve(response);
      }, err => {
        reject(err)
      })
  })
}
export function downLoadPost(url, data = {}) {
  console.log("downLoad====")

  return new Promise((resolve, reject) => {
    console.log(service)
    service.defaults.timeout = 5000000
    service.post(url, data, {
      responseType: 'blob'
    },)
      .then(response => {
        console.log(response, 'response')
        resolve(response);
      }, err => {
        reject(err)
      })
  })
}


export default service
